import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import '../Css/Home.css';
import logoImage from '../assets/svk-maid-logo.png';

const Home = () => {
  const [userType, setUserType] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);
  const [urgency, setUrgency] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showMobileInput, setShowMobileInput] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleUserTypeSelect = (type) => {
    setUserType(type);
    if (type === "Employment") setShowMobileInput(true);
  };

  const handleServiceSelect = (service) => setSelectedService(service);
  const handleGenderSelect = (gender) => setSelectedGender(gender);
  const handleUrgencySelect = (level) => {
    setUrgency(level);
    setShowMobileInput(true);
  };

  const handleBack = () => {
    if (showMobileInput) {
      setShowMobileInput(false);
      if (userType === "Employment") setUserType(null);
      else setUrgency(null);
    } else if (urgency) setUrgency(null);
    else if (selectedGender) setSelectedGender(null);
    else if (selectedService) setSelectedService(null);
    else if (userType) setUserType(null);
  };

  const handleContinue = () => {
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(mobileNumber)) {
      alert("Please enter a valid 10-digit mobile number starting with 6-9.");
      return;
    }

    let message = "";
    if (userType === "Service") {
      message = `Hello, I am interested in maid service.\n\nService: ${selectedService}\nGender Preference: ${selectedGender}\nUrgency: ${urgency}\nMobile: +91${mobileNumber}`;
    } else {
      message = `Hello, I am looking for a job.\n\nPlease contact me.\nMobile: +91${mobileNumber}`;
    }

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/918691812620?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <>
    {/* <Popup/> */}
      {/* <Header /> */}
      <div className="maid-service-section" id="home">
        <div className="form-container">
          <div className="form-card">
            <img src={logoImage} alt="Logo" className="form-logo" />
            {!userType ? (
              <>
                <p className="form-question">What are you looking for? <br /><span style={{ fontSize: '0.9em' }}>आप क्या खोज रहे हैं?</span></p>
                <div className="service-options">
                  <div className="option" onClick={() => handleUserTypeSelect("Service")}>🙋‍♂️ <span>I need a service <br />मुझे सेवा चाहिए</span></div>
                  <div className="option" onClick={() => handleUserTypeSelect("Employment")}>💼 <span>I want to work <br />मैं काम करना चाहता/चाहती हूँ</span></div>
                </div>
              </>
            ) : userType === "Service" && !selectedService ? (
              <>
                <button className="back-button" onClick={handleBack}>⟵ Back</button>
                <p className="form-question">What do you want your maid to do? <br /><span style={{ fontSize: '0.9em' }}>आप अपनी मेड से क्या करवाना चाहते हैं?</span></p>
                <div className="service-options">
                  <div className="option" onClick={() => handleServiceSelect("Maid")}>🧹<span>Maid <br />सफाई</span></div>
                  <div className="option" onClick={() => handleServiceSelect("Cooking")}>👩‍🍳<span>Cooking <br />खाना बनाना</span></div>
                  <div className="option" onClick={() => handleServiceSelect("Baby Sitting")}>👶<span>Baby Sitting <br />बच्चों की देखभाल</span></div>
                  <div className="option" onClick={() => handleServiceSelect("Patient & Elderly Care")}>👵<span>Patient & Elderly Care <br />मरीज और बुजुर्गों की देखभाल</span></div>
                </div>
              </>
            ) : userType === "Service" && !selectedGender ? (
              <>
                <button className="back-button" onClick={handleBack}>⟵ Back</button>
                <p className="form-question">Which gender do you prefer? <br /><span style={{ fontSize: '0.9em' }}>आप किस लिंग को प्राथमिकता देते हैं?</span></p>
                <div className="gender-card">
                  <p className="gender-label">Select preferred Gender <br /><span style={{ fontSize: '0.9em' }}>पसंद का लिंग चुनें</span></p>
                  <div className="gender-options">
                    <div className="gender-option" onClick={() => handleGenderSelect("Male")}> <img src={require("../assets/male-removebg-preview.png")} alt="Male" /> <p>Male <br />पुरुष</p></div>
                    <div className="gender-option" onClick={() => handleGenderSelect("Female")}> <img src={require("../assets/femal-removebg-preview.png")} alt="Female" /> <p>Female <br />महिला</p></div>
                    <div className="gender-option" onClick={() => handleGenderSelect("Any")}> <img src={require("../assets/any-removebg-preview.png")} alt="Any" /> <p>Any <br />कोई भी</p></div>
                  </div>
                </div>
              </>
            ) : userType === "Service" && !urgency ? (
              <>
                <button className="back-button" onClick={handleBack}>⟵ Back</button>
                <p className="form-question">How urgent is your requirement? <br /><span style={{ fontSize: '0.9em' }}>आपकी आवश्यकता कितनी जरूरी है?</span></p>
                <div className="urgency-options">
                  <div className="urgency-option" onClick={() => handleUrgencySelect("Urgent")}>📅 <strong>Urgent requirement <br />तत्काल आवश्यकता</strong><p>We will contact you as soon as possible <br />हम जल्द से जल्द आपसे संपर्क करेंगे</p></div>
                  <div className="urgency-option" onClick={() => handleUrgencySelect("Not Urgent")}>📅 <strong>Not so urgent requirement <br />कम जरूरी आवश्यकता</strong><p>We will contact you within 7 working days <br />हम 7 कार्यदिवसों के भीतर संपर्क करेंगे</p></div>
                  <div className="urgency-option" onClick={() => handleUrgencySelect("Just Checking")}>🔍 <strong>Just checking the site <br />सिर्फ साइट देख रहा हूँ</strong><p>We will not contact you <br />हम आपसे संपर्क नहीं करेंगे</p></div>
                </div>
              </>
            ) : showMobileInput ? (
              <>
                <button className="back-button" onClick={handleBack}>⟵ Back</button>
                <p className="form-question">Enter your mobile no. <br /><span style={{ fontSize: '0.9em' }}>अपना मोबाइल नंबर दर्ज करें</span></p>
                <div className="mobile-input-group">
                  <span className="country-code">+91</span>
                  <input type="tel" maxLength="10" className="mobile-input" placeholder="Enter Mobile Number / मोबाइल नंबर दर्ज करें" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
                </div>
                <button className="continue-button" onClick={handleContinue}>Continue <br />जारी रखें</button>
                <p className="form-terms">By clicking Continue, I accept the <a href="#">terms of use</a> and <a href="#">privacy policy</a>.<br />जारी रखने पर मैं <a href="#">उपयोग की शर्तें</a> और <a href="#">गोपनीयता नीति</a> स्वीकार करता/करती हूँ।</p>
              </>
            ) : null}
          </div>
        </div>
      </div>

    </>
  );
};

export default Home;
